
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import defineModule0 from "./-embroider-implicit-modules.js";

import * as amdModule0 from "./adapters/application.js"
import * as amdModule1 from "./config/environment.ts"
import * as amdModule2 from "./deprecation-workflow.ts"
import * as amdModule3 from "./handlers/date_as_utc.ts"
import * as amdModule4 from "./misc/activeItems.json"
import * as amdModule5 from "./misc/createExampleItems.ts"
import * as amdModule6 from "./misc/createExampleLocation.ts"
import * as amdModule7 from "./misc/createExampleOrders.ts"
import * as amdModule8 from "./misc/createExampleProductGroups.ts"
import * as amdModule9 from "./misc/createExampleStocktakings.ts"
import * as amdModule10 from "./misc/createExampleSuppliers.ts"
import * as amdModule11 from "./misc/createExampleUsers.ts"
import * as amdModule12 from "./misc/decorators.ts"
import * as amdModule13 from "./misc/transition.ts"
import * as amdModule14 from "./models/company.ts"
import * as amdModule15 from "./models/item.ts"
import * as amdModule16 from "./models/location-item.ts"
import * as amdModule17 from "./models/location.ts"
import * as amdModule18 from "./models/order-entry.ts"
import * as amdModule19 from "./models/order.ts"
import * as amdModule20 from "./models/product-group.ts"
import * as amdModule21 from "./models/stocktaking-entry.ts"
import * as amdModule22 from "./models/stocktaking.ts"
import * as amdModule23 from "./models/supplier-item.ts"
import * as amdModule24 from "./models/supplier.ts"
import * as amdModule25 from "./models/user.ts"
import * as amdModule26 from "./router.ts"
import * as amdModule27 from "./serializers/application.js"
import * as amdModule28 from "./services/download.ts"
import * as amdModule29 from "./services/modal.ts"
import * as amdModule30 from "./services/notification.ts"
import * as amdModule31 from "./services/session.ts"
import * as amdModule32 from "./services/stocktaking.ts"
import * as amdModule33 from "./services/store.js"
import * as amdModule34 from "./transforms/boolean.js"
import * as amdModule35 from "./transforms/date.js"
import * as amdModule36 from "./transforms/number.js"
import * as amdModule37 from "./transforms/string.js"
import * as amdModule38 from "./services/page-title.js"
import * as amdModule39 from "./services/keyboard.js"
import * as amdModule40 from "./data-adapter.js"
import * as amdModule41 from "./templates/auth.gts"
import * as amdModule42 from "./routes/auth.ts"
import * as amdModule43 from "./templates/auth/admin.gts"
import * as amdModule44 from "./routes/auth/admin.ts"
import * as amdModule45 from "./templates/auth/basic-data.gts"
import * as amdModule46 from "./routes/auth/basic-data.ts"
import * as amdModule47 from "./templates/auth/basic-data/item.gts"
import * as amdModule48 from "./routes/auth/basic-data/item.ts"
import * as amdModule49 from "./templates/auth/basic-data/location.gts"
import * as amdModule50 from "./routes/auth/basic-data/location.ts"
import * as amdModule51 from "./templates/auth/basic-data/supplier.gts"
import * as amdModule52 from "./routes/auth/basic-data/supplier.ts"
import * as amdModule53 from "./templates/auth/index.gts"
import * as amdModule54 from "./routes/auth/index.ts"
import * as amdModule55 from "./templates/auth/location.gts"
import * as amdModule56 from "./routes/auth/location.ts"
import * as amdModule57 from "./templates/auth/orders.gts"
import * as amdModule58 from "./routes/auth/orders.ts"
import * as amdModule59 from "./templates/auth/orders/accept.gts"
import * as amdModule60 from "./routes/auth/orders/accept.ts"
import * as amdModule61 from "./templates/auth/orders/edit.gts"
import * as amdModule62 from "./routes/auth/orders/edit.ts"
import * as amdModule63 from "./templates/auth/orders/index.gts"
import * as amdModule64 from "./routes/auth/orders/index.ts"
import * as amdModule65 from "./templates/auth/orders/new.gts"
import * as amdModule66 from "./routes/auth/orders/new.ts"
import * as amdModule67 from "./templates/auth/orders/show.gts"
import * as amdModule68 from "./routes/auth/orders/show.ts"
import * as amdModule69 from "./templates/auth/stocktaking.gts"
import * as amdModule70 from "./routes/auth/stocktaking.ts"
import * as amdModule71 from "./templates/auth/stocktaking/index.gts"
import * as amdModule72 from "./routes/auth/stocktaking/index.ts"
import * as amdModule73 from "./templates/auth/stocktaking/name.gts"
import * as amdModule74 from "./routes/auth/stocktaking/name.js"
import * as amdModule75 from "./templates/auth/views/proposed.gts"
import * as amdModule76 from "./routes/auth/views/proposed.ts"
import * as amdModule77 from "./templates/auth/views/suppliers.gts"
import * as amdModule78 from "./routes/auth/views/suppliers.ts"
import * as amdModule79 from "./templates/login.gts"
import * as amdModule80 from "./routes/login.ts"
import * as amdModule81 from "./templates/register.gts"
import * as amdModule82 from "./routes/register.ts"
import * as amdModule83 from "./templates/application.gts"

let exportFastbootModules = {};





export default Object.assign(
  {},
defineModule0,
  {
"bcl/adapters/application": amdModule0,
"bcl/config/environment": amdModule1,
"bcl/deprecation-workflow": amdModule2,
"bcl/handlers/date_as_utc": amdModule3,
"bcl/misc/activeItems": amdModule4,
"bcl/misc/createExampleItems": amdModule5,
"bcl/misc/createExampleLocation": amdModule6,
"bcl/misc/createExampleOrders": amdModule7,
"bcl/misc/createExampleProductGroups": amdModule8,
"bcl/misc/createExampleStocktakings": amdModule9,
"bcl/misc/createExampleSuppliers": amdModule10,
"bcl/misc/createExampleUsers": amdModule11,
"bcl/misc/decorators": amdModule12,
"bcl/misc/transition": amdModule13,
"bcl/models/company": amdModule14,
"bcl/models/item": amdModule15,
"bcl/models/location-item": amdModule16,
"bcl/models/location": amdModule17,
"bcl/models/order-entry": amdModule18,
"bcl/models/order": amdModule19,
"bcl/models/product-group": amdModule20,
"bcl/models/stocktaking-entry": amdModule21,
"bcl/models/stocktaking": amdModule22,
"bcl/models/supplier-item": amdModule23,
"bcl/models/supplier": amdModule24,
"bcl/models/user": amdModule25,
"bcl/router": amdModule26,
"bcl/serializers/application": amdModule27,
"bcl/services/download": amdModule28,
"bcl/services/modal": amdModule29,
"bcl/services/notification": amdModule30,
"bcl/services/session": amdModule31,
"bcl/services/stocktaking": amdModule32,
"bcl/services/store": amdModule33,
"bcl/transforms/boolean": amdModule34,
"bcl/transforms/date": amdModule35,
"bcl/transforms/number": amdModule36,
"bcl/transforms/string": amdModule37,
"bcl/services/page-title": amdModule38,
"bcl/services/keyboard": amdModule39,
"bcl/data-adapter": amdModule40,
"bcl/templates/auth": amdModule41,
"bcl/routes/auth": amdModule42,
"bcl/templates/auth/admin": amdModule43,
"bcl/routes/auth/admin": amdModule44,
"bcl/templates/auth/basic-data": amdModule45,
"bcl/routes/auth/basic-data": amdModule46,
"bcl/templates/auth/basic-data/item": amdModule47,
"bcl/routes/auth/basic-data/item": amdModule48,
"bcl/templates/auth/basic-data/location": amdModule49,
"bcl/routes/auth/basic-data/location": amdModule50,
"bcl/templates/auth/basic-data/supplier": amdModule51,
"bcl/routes/auth/basic-data/supplier": amdModule52,
"bcl/templates/auth/index": amdModule53,
"bcl/routes/auth/index": amdModule54,
"bcl/templates/auth/location": amdModule55,
"bcl/routes/auth/location": amdModule56,
"bcl/templates/auth/orders": amdModule57,
"bcl/routes/auth/orders": amdModule58,
"bcl/templates/auth/orders/accept": amdModule59,
"bcl/routes/auth/orders/accept": amdModule60,
"bcl/templates/auth/orders/edit": amdModule61,
"bcl/routes/auth/orders/edit": amdModule62,
"bcl/templates/auth/orders/index": amdModule63,
"bcl/routes/auth/orders/index": amdModule64,
"bcl/templates/auth/orders/new": amdModule65,
"bcl/routes/auth/orders/new": amdModule66,
"bcl/templates/auth/orders/show": amdModule67,
"bcl/routes/auth/orders/show": amdModule68,
"bcl/templates/auth/stocktaking": amdModule69,
"bcl/routes/auth/stocktaking": amdModule70,
"bcl/templates/auth/stocktaking/index": amdModule71,
"bcl/routes/auth/stocktaking/index": amdModule72,
"bcl/templates/auth/stocktaking/name": amdModule73,
"bcl/routes/auth/stocktaking/name": amdModule74,
"bcl/templates/auth/views/proposed": amdModule75,
"bcl/routes/auth/views/proposed": amdModule76,
"bcl/templates/auth/views/suppliers": amdModule77,
"bcl/routes/auth/views/suppliers": amdModule78,
"bcl/templates/login": amdModule79,
"bcl/routes/login": amdModule80,
"bcl/templates/register": amdModule81,
"bcl/routes/register": amdModule82,
"bcl/templates/application": amdModule83,
  },
  exportFastbootModules
);
